<!--<h1 mat-dialog-title>Hi {{data.name}}</h1>-->
<button mat-button class="close-icon" [mat-dialog-close]="true">
    <mat-icon>X</mat-icon>
</button>
<div mat-dialog-content>


    <img src="{{data.imageLg}}" alt="{{data.alt}}" />
</div>

